// Nucleus & Tailwind CSS classes are supported for the rich content editor
export default {
    heading: {
        h1: 'text-xl font-semibold',
        h2: 'text-lg font-semibold',
        h3: 'text-base font-semibold',
    },
    list: {
        ol: 'list-decimal',
        ul: 'list-disc',
    },
    text: {
        italic: 'italic',
        underline: 'underline',
    },
};
